import { useLocation, useNavigate } from 'react-router-dom'

import { StyledTab, StyledTabs } from 'common/components/StyledTabs'

import { IDataViewProps } from 'features/DataManagement/DataView'

const ViewsAndMyViewsTabs = ({ dvBasePath }: IDataViewProps) => {
  const navigate = useNavigate()
  const { search } = useLocation()

  const handleTabSelect = () => {
    navigate(`${dvBasePath}/list/views${search}`)
  }

  return (
    <StyledTabs
      value={0}
      onChange={handleTabSelect}
      style={{ minHeight: '40px' }}
    >
      <StyledTab label='VIEWS' sx={{ minHeight: '40px', height: '40px' }} />
    </StyledTabs>
  )
}

export default ViewsAndMyViewsTabs
